import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid2,
  Box,
} from "@mui/material";
import VideoCall from "@mui/icons-material/VideoCall"; // Ensure this import exists
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";

function UpcomingMeetings() {
  const upcomingMeetingsList = [
    {
      date: "Fri, 14th Feb 2025",
      title: "Meeting with Emma Sri Martini",
      designation: "Director of Finance",
      discussionTopics: [
        {
          title: "Overdue Payments",
          description:
            "Discuss the reasons for delayed payments and potential impacts on the client’s credit profile. Explore short-term options to ease repayment pressures.",
        },
        {
          title: "Low Credit Utilization",
          description: "Understand the reasons for underutilization.",
        },
      ],
      location: "Conference Call",
      time: "10:00 AM",
    },
    {
      date: "Tue, 18th Feb 2025",
      title: "Meeting with Emma Sri Martini",
      designation: "Director of Finance",
      discussionTopics: [
        {
          title: "Overdue Covenants",
          description:
            "Highlight the breached covenants and clarify the implications (e.g., loan repricing, restricted access to future credit).Collaborate on an action plan to restore compliance​.",
        },
      ],
      location: "Grha BNI – 25th Floor Meeting Room 1",
      time: "03:30 PM",
    },
  ];

  return (
    <div style={{ height: "40vh", overflowY: "auto" }} className="pt-1 px-2">
      <Box>
      <div className="text-xs text-gray-500 italic flex justify-end mr-2">
          <span className="border-b-2 border-t-2 border-gray-500">
            {" "}
            Illustrative
          </span>
        </div>
        {upcomingMeetingsList.map((item, index) => (
          <Box key={index}>
            <Card className="mb-4 shadow-md">
              <CardContent>
                <div
                  className="text-xs font-bold p-2 mb-2 rounded w-[8rem]"
                  style={{ backgroundColor: "lightgray", color: "black" }}
                >
                  {item.date}
                </div>
                <Grid2 container>
                  <Grid2 item xs={12} md={8}>
                    <Grid2
                      container
                      sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                      gap={8}
                    >
                      <Grid2 item md={6}>
                        <div className="flex items-center gap-2">
                          <CalendarMonthOutlinedIcon color="primary" />
                          <div>
                            <div className="text-sm font-bold">
                              {item.title}
                            </div>
                            <div className="text-xs ">{item.designation}</div>
                          </div>
                        </div>
                      </Grid2>
                      <Grid2
                        item
                        md={6}
                        sx={{ borderLeft: "1px solid lightgrey" }}
                      >
                        <div className="flex items-center gap-2 ml-6">
                          <VideoCall color="primary" />
                          <div className="text-xs font-bold">
                            {item.location}
                          </div>
                        </div>
                        <div className="flex items-center gap-2 ml-6">
                          <AccessTimeOutlinedIcon color="primary" />
                          <div className="text-xs font-bold">{item.time}</div>
                        </div>
                      </Grid2>
                    </Grid2>
                  </Grid2>
                  <Grid2 item>
                    <Box className="mt-4">
                      <div className="text-sm font-bold my-2">
                        Discussion Topics
                      </div>
                      <ul className="list-disc ml-6 text-gray-600">
                        {item.discussionTopics.map((topic, topicIndex) => (
                          <li key={topicIndex} className="text-xs">
                            <span className="font-bold">
                              <strong>{topic.title}:</strong>
                            </span>{" "}
                            {topic.description}
                          </li>
                        ))}
                      </ul>
                    </Box>
                  </Grid2>
                </Grid2>
              </CardContent>
            </Card>
          </Box>
        ))}
      </Box>
    </div>
  );
}

export default UpcomingMeetings;
